import { render, staticRenderFns } from "./adminPanel.vue?vue&type=template&id=5e0f4b75"
import script from "./adminPanel.vue?vue&type=script&lang=js"
export * from "./adminPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports